module.exports = require("react");


//////////////////
// WEBPACK FOOTER
// external {"commonjs2":"react"}
// module id = 3
// module chunks = 0